export const TH = {
  "Open document": "à¹à¸à¸´à¸à¹à¸­à¸à¸ªà¸²à¸£",
  "Upload file": "à¸­à¸±à¸à¹à¸«à¸¥à¸à¹à¸à¸¥à¹",
  "Drop file here to upload": "à¸§à¸²à¸à¹à¸à¸¥à¹à¸à¸µà¹à¸à¸µà¹à¹à¸à¸·à¹à¸­à¸­à¸±à¸à¹à¸«à¸¥à¸",
  "Disc": "à¸à¸´à¸ªà¸à¹",
  "URL": "URL",
  "FILE": "à¹à¸à¸¥à¹",
  "SIZE": "à¸à¸à¸²à¸",
  "MB": "MB",
  "KB": "KB",
  "Bytes": "à¹à¸à¸à¹",
  "Loading... Please wait.": "à¸à¸³à¸¥à¸±à¸à¹à¸«à¸¥à¸... à¸à¸£à¸¸à¸à¸²à¸£à¸­à¸ªà¸±à¸à¸à¸£à¸¹à¹",
  "Fit Width": "à¸à¸­à¸à¸µà¸à¸§à¸²à¸¡à¸à¸§à¹à¸²à¸",
  "Fit Height": "à¸à¸­à¸à¸µà¸à¸±à¸à¸à¸§à¸²à¸¡à¸ªà¸¹à¸",
  "Password protected document": "à¹à¸­à¸à¸ªà¸²à¸£à¸à¹à¸­à¸à¸à¸±à¸à¸à¹à¸§à¸¢à¸£à¸«à¸±à¸ªà¸à¹à¸²à¸",
  "Password": "à¸£à¸«à¸±à¸ªà¸à¹à¸²à¸",
  "Open": "à¹à¸à¸´à¸",
  "Password Required": "à¸à¹à¸­à¸à¹à¸à¹à¸£à¸«à¸±à¸ªà¸à¹à¸²à¸",
  "Incorrect password": "à¸£à¸«à¸±à¸ªà¸à¹à¸²à¸à¸à¸´à¸à¸à¸¥à¸²à¸",
  "Error": "à¸à¹à¸­à¸à¸´à¸à¸à¸¥à¸²à¸",
  "Something went wrong": "à¸­à¸°à¹à¸£à¸à¸²à¸à¸­à¸¢à¹à¸²à¸à¸à¸´à¸à¸à¸à¸à¸´",
  "Server is not available": "à¹à¸à¸´à¸£à¹à¸à¹à¸§à¸­à¸£à¹à¹à¸¡à¹à¸à¸£à¹à¸­à¸¡à¹à¸à¹à¸à¸²à¸",
  "of": "à¸à¸­à¸",
  "Please wait...": "à¹à¸à¸£à¸à¸£à¸­..."
};
